"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Engine = require('./engine').queryc;

var util = require('../util');

var NonWallet =
/**
 * @constructor
 * @param {*} net - Network id
 */
function NonWallet(net) {
  var _this = this;

  _classCallCheck(this, NonWallet);

  _defineProperty(this, "init", function (callback) {
    var engine = new Engine(_this.network); // We used callback to fomalize code interface with other classes

    return callback(null, engine.web3);
  });

  this.network = util.getNetworkId(net, 'number');
}
/**
 * @func init
 * Initialize web3 
 * @param {*} callback 
 */
;

module.exports = NonWallet;